//Plataformas

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useClientNavigation } from '../hooks/useClientNavigation.mjs';
import { styles } from '../styles/plataformas.mjs';
import { apiUrl, apiUrl3 } from '../api/client.mjs';


const PlataformaItem = ({ plataforma, onEdit, onDelete }) => {
    return (
        <tr style={styles.itemPlataforma}>
            <td style={{ wordWrap: 'break-word', maxWidth: '100%' }}>{plataforma.url}</td>
            <td>
                <button onClick={() => onEdit(plataforma.id)} style={styles.botaoAcao}>Editar</button>
            </td>
            <td>
                <button onClick={() => onDelete(plataforma.id)} style={styles.botaoAcao}>Excluir</button>
            </td>
        </tr>
    );
};

const Plataformas = () => {
    const [plataformas, setPlataformas] = useState([]);
    const { navigateToClient } = useClientNavigation();

    useEffect(() => {
        axios.get(apiUrl('promocional'))
            .then(response => {
                const sortedPlataformas = response.data.sort((a, b) => a.ordem - b.ordem);
                setPlataformas(sortedPlataformas);
            })
            .catch(error => console.error('Falha ao carregar plataformas:', error));
    }, []);

    const handleAddClick = () => {
        navigateToClient('/formPlat');
    };

    const handleEditClick = (id) => {
        navigateToClient(`/formPlat/${id}`);
    };

    const handleEditPositionClick = () => {
        navigateToClient('/plataformas/EditarPosicao');
    };

    const handleDelete = (id) => {
        const url = apiUrl3(id);
        axios.delete(url)
            .then(() => {
                setPlataformas(prev => prev.filter(p => p.id !== id));
            })
            .catch(error => console.log("Delete failed: " + error.message));
    };

    return (
        <div style={styles.container}>
            <h2>Adicione suas plataformas de divulgação</h2>
            <span>Aqui, você cadastra as plataformas que quer divulgar sem ser lançamento.</span>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <button onClick={handleEditPositionClick} style={styles.botaoAdicionar}>Editar Posição</button>
                <button onClick={handleAddClick} style={styles.botaoAdicionar}>Adicionar Plataforma</button>
            </div>
            <table>
                <tbody>
                    {plataformas.map((plataforma) => (
                        <PlataformaItem
                            key={plataforma.id}
                            plataforma={plataforma}
                            onEdit={handleEditClick}
                            onDelete={handleDelete}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Plataformas;
